import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  root: {
    height: '100%',
    overflow: 'auto',
    display: 'flex',
    flexDirection: 'column',
    '& .infinite-scroll-component__outerdiv': {
      flex: 1,
    },
  },
  emptyRoot: {
    height: '100%',
    display: 'flex',
  },
  markAllAsRead: {
    height: theme.spacing(3),
    textAlign: 'end',
    margin: theme.spacing(1, 1),

    '& .MuiTypography-root': {
      color: theme.palette.primary.light,
      cursor: 'pointer',

      '&:hover': {
        textDecoration: 'underline',
      },
      '&.disabled': {
        color: theme.palette.action.disabled,

        '&:hover': {
          textDecoration: 'none',
        },
      },
    },
  },
}));
